import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLbi = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 152,
	height: 150,
	viewBox: "0 0 152 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M138.899 149.235C150.13 149.17 153.685 141.018 151.291 133.754C148.548 125.486 127.336 63.0404 127.336 63.0404C127.336 63.0404 105.488 128.868 102.718 137.473C98.3187 151.256 79.2436 146.095 83.64 131.145C88.0365 116.195 115.093 31.5399 118.507 21.1532C122.984 7.48631 129.073 1.00057 142.749 0.0872566C133.458 0.0215934 87.9887 -0.0858553 75.9127 0.120088C63.8366 0.326032 56.0077 8.37276 53.035 17.8044C50.0622 27.236 20.2929 120.418 17.4575 129.48C14.031 140.356 7.12147 146.94 0 149.235C9.89724 149.011 138.899 149.235 138.899 149.235Z",
		fill: "currentColor"
	})
});
export default SvgLbi;
